export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = 'c5c34523-3231-46fb-99c2-841790b1b283';
export const MODAL_CLOSE_SEC = 2.5;
